import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
  roles: { count: 0, rows: [] },
  loading: false,
  checkDelete: {}
};

const requestRolesStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchRolesSuccess = (state, action) => {
  return updateObject(state, {
    roles: action.roles,
    loading: false
  });
};

const requestRolesFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteRolesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const checkDeleteRolesSuccess = (state, action) => {
  return updateObject(state, { 
    checkDelete: action.checkDelete,
    loading: false 
  });
}

const updateRolesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const postRolesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_ROLES_START: return requestRolesStart(state, action);
    case actionTypes.FETCH_ROLES_SUCCESS: return fetchRolesSuccess(state, action);
    case actionTypes.REQUEST_ROLES_FAIL: return requestRolesFail(state, action);
    case actionTypes.DELETE_ROLES_SUCCESS: return deleteRolesSuccess(state, action);
    case actionTypes.CHECK_DELETE_ROLES_SUCCESS: return checkDeleteRolesSuccess(state, action);
    case actionTypes.UPDATE_ROLES_SUCCESS: return updateRolesSuccess(state, action);
    case actionTypes.POST_ROLES_SUCCESS: return postRolesSuccess(state, action);

    default: return state;
  }
};

export default reducer;